/**
 * True while scripts/prerender*.ts is capturing the page in Puppeteer. Effects
 * that only make sense in a live browser (loading video, writing scroll-linked
 * styles, measuring layout) skip themselves, so the static HTML is the page as
 * rendered and not a snapshot of some mid-animation state.
 */
export const isPrerender = () =>
  typeof window !== "undefined" &&
  (window as unknown as { __PRERENDER__?: boolean }).__PRERENDER__ === true;
